import React from 'react';
import VideoAsset, {
  VideoAssetProps,
} from 'blocks/Timeline/components/VideoAsset';
import useVideoClipAsset, { UseVideoClipAssetProps } from './useVideoClipAsset';

type VideoClipAssetProps = UseVideoClipAssetProps &
  Pick<VideoAssetProps, 'aspectRatio'>;

function VideoClipAsset(props: VideoClipAssetProps) {
  const videoAssetData = useVideoClipAsset(props);

  return <VideoAsset {...videoAssetData} {...props} />;
}

export default VideoClipAsset;
